import { NgModule } from '@angular/core';
import { NumberOnlyDirective } from './directives/number-only.directive';

@NgModule({
  imports: [],
  declarations: [
    NumberOnlyDirective
  ],
  exports: [
    NumberOnlyDirective
  ]
})

export class SharedModule {}
